<div
  id="device-info-table-container"
  class="matp-table-container tw-max-h-[calc(100vh_-_250px)]"
>
  <div class="matp-table-actions-area !tw-mb-2">
    <div class="matp-table-actions tw-flex">
      <div class="tw-flex tw-ml-auto tw-h-full">
        <button
          mat-raised-button
          id="filter-clear-btn"
          class="tw-mr-2"
          (click)="clearFilters()"
        >
          <mat-icon>restart_alt</mat-icon>
          <span>クリア</span>
        </button>
        <button
          mat-raised-button
          id="add-btn"
          color="primary"
          (click)="exportDeviceList()"
        >
          <mat-icon>Download</mat-icon>
          <span>CSVエクスポート（BOM付）</span>
        </button>

        <button
          mat-icon-button
          id="menu-btn"
          class="!tw-h-10 !tw-w-10 tw-text-[1.8rem] !tw-p-1 tw-mx-2"
          [mat-menu-trigger-for]="menuFilter"
        >
          <mat-icon class="matp-icon-default">filter_list</mat-icon>
        </button>
        <mat-menu #menuFilter="matMenu">
          <ng-container *ngFor="let option of options">
            <button mat-menu-item (click)="$event.stopPropagation()">
              <mat-checkbox
                [(ngModel)]="option.checked"
                [disabled]="option.disabled"
                (change)="updateDisplayList()"
                color="primary"
              >
                {{ option.displayName }}
              </mat-checkbox>
            </button>
          </ng-container>
        </mat-menu>
      </div>
    </div>
  </div>

  <div class="matp-table-area">
    <table
      id="device-info-table"
      class="matp-table"
      mat-table
      matSort
      [matSortActive]="initSortState.active"
      [matSortDirection]="initSortState.direction"
      [dataSource]="dataSource"
    >
      <!-- デバイス名 -->
      <ng-container matColumnDef="deviceName">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            デバイス名
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="deviceNameFilter"
              type="text"
              [(ngModel)]="deviceNameKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="devicename-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearDeviceNameFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td name="deviceName" mat-cell *matCellDef="let element">
          <a
            [routerLink]="['/device-info', element.serialNo]"
            [queryParams]="{ page: 'device-info' }"
          >
            {{ element.deviceName }}
          </a>
        </td>
      </ng-container>

      <!-- シリアル番号 -->
      <ng-container matColumnDef="serialNo">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-24">
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            シリアル番号
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="serialNoFilter"
              type="text"
              [(ngModel)]="serialNoKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="serialno-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearSerialNoFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="serialNo" *matCellDef="let element">
          {{ element.serialNo }}
        </td>
      </ng-container>

      <!-- デバイス種類 -->
      <ng-container matColumnDef="deviceType">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            デバイス種類
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <mat-select
              [(ngModel)]="selectedDeviceType"
              name="deviceTypeFilter"
              panelClass="matp-table-select-panel"
              (selectionChange)="applyFilter()"
            >
              <mat-option [value]="null"></mat-option>
              <mat-option
                *ngFor="let deviceType of deviceTypes"
                [value]="deviceType"
              >
                {{ deviceType }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td
          mat-cell
          name="deviceType"
          *matCellDef="let element"
          class="tw-w-20"
        >
          {{ element.deviceType }}
        </td>
      </ng-container>

      <!-- 最終通信日時 -->
      <ng-container matColumnDef="lastCommunicationAt">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            最終更新日時
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="lastCommunicationAtFilter"
              type="text"
              [(ngModel)]="lastCommunicationAtKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="lastCommunicationat-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearLastCommunicationAtFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="lastCommunicationAt" *matCellDef="let element">
          {{ element.lastCommunicationAt | date: " yyyy/MM/dd HH:mm:ss" }}
        </td>
      </ng-container>

      <!-- ステータス -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            ステータス
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="statusFilter"
              type="text"
              [(ngModel)]="statusKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="status-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearStatusFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="status" *matCellDef="let element">
          <ng-container *ngIf="element.validContractState; else contractEnded">
            {{ element.status }}
          </ng-container>
          <ng-template #contractEnded>
            <span style="color: red">{{ element.status }}</span>
          </ng-template>
        </td>
      </ng-container>

      <!-- バッテリー -->
      <ng-container matColumnDef="battery">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-24">
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            バッテリー
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="batteryFilter"
              type="text"
              [(ngModel)]="batteryKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="battery-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearBatteryFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="battery" *matCellDef="let element">
          <div class="tw-flex tw-items-center">
            <div class="tw-w-10">
              {{ element.battery | numeral: "0" }}
              <span *ngIf="element.battery">%</span>
            </div>
            @if (element.battery) {
              <div class="tw-h-6 tw-ml-1">
                <app-battery-icon
                  [batteryPercentage]="element.battery"
                ></app-battery-icon>
              </div>
            }
          </div>
        </td>
      </ng-container>

      <!-- 設定グループ -->
      <ng-container matColumnDef="settingGroupName">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-24">
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            設定グループ
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="settingGroupFilter"
              type="text"
              [(ngModel)]="settingGroupKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="settinggroup-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearSettingGroupFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="settingGroupName" *matCellDef="let element">
          {{ element.settingGroupName }}
        </td>
      </ng-container>

      <!-- タグ -->
      <ng-container matColumnDef="tag">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            タグ
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="tagFilter"
              type="text"
              [(ngModel)]="tagKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="tag-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearTagFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="tag" *matCellDef="let element">
          <div *ngFor="let tag of element.tagList" class="tw-inline-block">
            <mat-card
              class="tw-m-2 tw-p-1 !tw-inline-block"
              [ngStyle]="tagStyle(tag.color)"
              >{{ tag.tagName }}</mat-card
            >
          </div>
        </td>
      </ng-container>

      <!-- 契約終了日 -->
      <ng-container matColumnDef="contractExpiredAt">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            契約終了日
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="contractExpiredAtFilter"
              type="text"
              [(ngModel)]="contractExpiredAtKeyword"
              (keyup)="applyFilter()"
            />
            <button
              id="contractexpiredat-filter-clear-btn"
              matSuffix
              mat-icon-button
              (click)="clearContractExpiredAtFilter()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell name="contractExpiredAt" *matCellDef="let element">
          {{ element.contractExpiredAt | date: "yyyy/MM/dd" : "+0900" }}
        </td>
      </ng-container>

      <!-- フライトモード -->
      <ng-container matColumnDef="fmd">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            フライトモード
          </div>
          <mat-form-field
            appearance="outline"
            class="matp-form-field-slim tw-mt-1"
          >
            <mat-select
              [(ngModel)]="selectedFmd"
              name="fmdFilter"
              panelClass="matp-table-select-panel"
              (selectionChange)="applyFilter()"
            >
              <mat-select-trigger>
                @if (selectedFmd === "active") {
                  <mat-icon>airplanemode_active</mat-icon>
                } @else if (selectedFmd === "inactive") {
                  <mat-icon>airplanemode_inactive</mat-icon>
                }
              </mat-select-trigger>

              <mat-option [value]="null"></mat-option>
              <mat-option [value]="'active'">
                <mat-icon>airplanemode_active</mat-icon>
              </mat-option>
              <mat-option [value]="'inactive'">
                <mat-icon>airplanemode_inactive</mat-icon>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td mat-cell name="fmd" *matCellDef="let element">
          @if (element.fmdEnabled === true && element.fmdOn === true) {
            <mat-icon>airplanemode_active</mat-icon>
          } @else if (element.fmdEnabled === true && element.fmdOn !== true) {
            <mat-icon>airplanemode_inactive</mat-icon>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{ '!tw-bg-gray-300': !row.validContractState }"
      ></tr>
    </table>
  </div>

  <mat-paginator
    id="device-info-table-paginator"
    [length]="dataSource.filteredData.length"
    hidePageSize
    showFirstLastButtons
  >
  </mat-paginator>
</div>
